export const RESTART_TIME = 2000 * 60;
